import { buildStoreDataUrl, API_CONFIG } from "@/shared/configs/apiConfig.js"
import getSample from '../raws/get.json'

export default {
  url(payload) {
    return buildStoreDataUrl({ service: 'lol', userId: 'lol' })
  },

  parse(raw = {}, payload = {}) {
    raw = getSample.riderMessages

    if (raw?.statusCode !== 200)
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to contact server',
        data: null,
        raw: null,
      }

    if (!Array.isArray(raw?.data))
      return {
        statusCode: 400,
        message: 'Unexpected data got from server. Expecting Array',
        data: null,
        raw,
      }

    // === Mapping des données ===
    let data = raw.data.map(message => ({
      id: message.id,
      senderId: message.senderId,
      senderName: message.senderName,
      senderRole: message.senderRole,
      message: message.message,
      timestamp: message.timestamp,
      status: message.status,
      orderId: message.orderId,
      attachments: message.attachments || [],
      isFromCustomer: message.isFromCustomer,
      isUnread: message.status === 'unread',
      timeAgo: this.getTimeAgo(new Date(message.timestamp)),
    }))

    // === Filtrage selon payload ===
    const { status, orderId, senderRole } = payload || {}
    if (status && status !== 'all') {
      data = data.filter(item => item.status === status)
    }
    if (orderId) {
      data = data.filter(item => item.orderId === orderId)
    }
    if (senderRole && senderRole !== 'all') {
      data = data.filter(item => item.senderRole === senderRole)
    }

    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]

        // Gestion des strings, nombres et dates
        if (typeof valA === 'string' && typeof valB === 'string') {
          return valA.localeCompare(valB) * order
        }
        if (typeof valA === 'number' && typeof valB === 'number') {
          return (valA - valB) * order
        }
        if (valA instanceof Date && valB instanceof Date) {
          return (valA.getTime() - valB.getTime()) * order
        }
        return 0
      })
    } else {
      // Tri par défaut: messages non lus en premier, puis par date décroissante
      data = [...data].sort((a, b) => {
        if (a.isUnread && !b.isUnread) return -1
        if (!a.isUnread && b.isUnread) return 1
        return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
      })
    }

    const { page = 0, limit = 10000 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: data.length,
        result: paginated,
        summary: {
          total: raw.data.length,
          unread: raw.data.filter(m => m.status === 'unread').length,
          read: raw.data.filter(m => m.status === 'read').length,
        },
      },
    }
  },

  // Helper function to calculate time ago
  getTimeAgo(date) {
    const seconds = Math.floor((new Date() - date) / 1000)

    let interval = Math.floor(seconds / 31536000)
    if (interval > 1) return interval + ' ans'

    interval = Math.floor(seconds / 2592000)
    if (interval > 1) return interval + ' mois'

    interval = Math.floor(seconds / 86400)
    if (interval > 1) return interval + ' jours'

    interval = Math.floor(seconds / 3600)
    if (interval > 1) return interval + ' heures'

    interval = Math.floor(seconds / 60)
    if (interval > 1) return interval + ' minutes'

    return "à l'instant"
  },
}
